import { REQUEST_URL } from "../constants";
import { PaginationQueryModel } from "../models";
import { RequestFileUtil, RequestUtil } from "../utils";

export const CareerService = {
  filterCareers,
  createCareer,
  updateCareer,
  deleteCareer,
  getCareerByCode,
  uploadImageCareer,
};

function filterCareers(
  query: PaginationQueryModel & {
    languageId?: string;
  } & {
    searchValue?: string;
  } & {
    status?: string[]
  } = {}
) {
  const url = REQUEST_URL.CAREER;
  const queryData: any = { ...query };

  return RequestUtil.get({ url, query: queryData });
}

function createCareer(data: FormData) {
  const url = REQUEST_URL.CAREER;

  return RequestUtil.post({ url, data });
}

function updateCareer(code: string, data: FormData) {
  const url = REQUEST_URL.CAREER_DETAIL.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

function deleteCareer(code: string) {
  const url = REQUEST_URL.CAREER_DETAIL.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}

function getCareerByCode(code: string) {
  const url = REQUEST_URL.CAREER_DETAIL.replace("{CODE}", code);

  return RequestUtil.get({ url });
}

function uploadImageCareer(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_CAREER;

  return RequestFileUtil.post({ url, data: formData });
}